import { z } from 'zod';
import { AccountSchema, BillingAddressSchema, BillingLanguageSchema } from '../../../../entities/account/account.schema';
/**
 * What may be changed about an account. Every field follows the same protocol
 * as the tenant mutations: `null` clears it, an omitted key leaves it alone.
 *
 * Die Stammdaten dürfen von beiden Seiten geändert werden (LIC-29): hier,
 * und im CRM. Was hier geschrieben wird, trägt der Abgleich hinaus — der
 * Schatten am Konto sorgt dafür, dass der nächste Lauf es nicht für eine
 * fremde Änderung hält und zurückschreibt.
 */ export const UpdateAccountRequestSchema = z.object({
    /**
   * The HubSpot company this customer is. Always the id, never a name — a
   * name-based lookup once sent an invoice to an unrelated company, which is
   * why the picker searches by name but assigns by id.
   */ hubspotCompanyId: z.string().nullable().optional(),
    /** The account this one belongs to. Grants nothing on its own (LIC-09). */ parentAccountId: z.string().nullable().optional(),
    /** Der Name, unter dem die Firma auf der Rechnung steht. */ companyName: z.string().trim().min(1).nullable().optional(),
    /** Wohin die Rechnung geht. */ billingEmail: z.email().nullable().optional(),
    billingAddress: BillingAddressSchema.nullable().optional(),
    /** An ihr hängt das Reverse Charge; eine geänderte wird neu geprüft. */ vatId: z.string().trim().min(4).nullable().optional(),
    /** Which language the invoice document is issued in. */ language: BillingLanguageSchema.optional(),
    /**
   * Ob die Verwalter der Arbeitsbereiche die Abrechnungsdaten selbst aendern
   * duerfen. Nur von hier aus zu setzen — der Schalter beschraenkt den
   * Kunden, also darf der Kunde ihn nicht umlegen.
   */ billingSelfService: z.boolean().optional()
});
export const UpdateAccountResponseSchema = z.object({
    account: AccountSchema
});

//# sourceMappingURL=update-account.schema.js.map